var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAnnouncementExit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.91,
    height: 15.91,
    viewBox: "0 0 15.91 15.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9337",
    "data-name": "Group 9337",
    transform: "translate(-1190 -391)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 20,
    height: 2.5,
    rx: 1,
    transform: "translate(1191.768 391) rotate(45)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 20,
    height: 2.5,
    rx: 1,
    transform: "translate(1190 405.142) rotate(-45)",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnnouncementExit);
export default __webpack_public_path__ + "static/media/IconAnnouncementExit.77799e52f0a24295e887f47ab4187bdc.svg";
export { ForwardRef as ReactComponent };